<template>
  <div class="mt-2 chart-wrapper p-2">
    <b-dropdown
      variant="link"
      toggle-class="p-0"
      class="select-dropdown"
      no-caret
    >
      <template #button-content>
        <div class="d-flex align-items-center">
          <h5 class="heading text-heavy mb-0">
            {{ selectedUsageType || 'Objects' }}
          </h5>
          <GjIcon
            class="icon-right"
            name="ArrowDown"
            size="17"
          />
        </div>
      </template>
      <b-dropdown-item
        :active="selectedUsageType === null"
        disabled
        @click="selectedUsageType = null"
      >
        Objects
      </b-dropdown-item>
      <b-dropdown-item
        :active="selectedUsageType === 'Storage'"
        @click="selectedUsageType = 'Storage'"
      >
        Storage
      </b-dropdown-item>
    </b-dropdown>
    <div class="mt-1 position-relative">
      <div
        v-if="gettingTimeLens"
        class="analytics-loading"
      >
        <b-spinner variant="primary" />
      </div>
      <vue-apex-charts
        v-else
        :key="`time-chart${gettingTimeLens}`"
        type="line"
        :height="340"
        :options="options"
        :series="series"
      />
    </div>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'RgwChart',
  components: { VueApexCharts },
  props: {
    interval: {
      type: Number,
      required: true,
    },
    bucket: {
      type: Object,
      required: true,
    },
    updateIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selectedUsageType: 'Storage',
    }
  },
  computed: {
    series() {
      return [
        {
          data: this.timeLensAnalytics.map(el => el.datapoint),
          name: 'Data',
        },
      ]
    },
    options() {
      return {
        chart: {
          id: 'cc',
          zoom: { enabled: false },
          type: 'line',
          dropShadow: {
            enabled: true,
            top: 18,
            left: 2,
            blur: 5,
            opacity: 0.2,
          },
          offsetX: -10,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
        },
        stroke: {
          show: true,
          curve: 'smooth',
          width: 4,
        },
        legend: {
          show: false,
        },
        colors: ['#df87f2'],
        markers: {
          size: 0,
          hover: {
            size: 5,
          },
        },
        xaxis: {
          labels: {
            offsetY: 5,
            style: {
              fontSize: '0.857rem',
            },
            axisBorder: {
              show: false,
            },
            tickPlacement: 'on',
          },
          tickAmount: 5,
          categories: this.timeLensAnalytics.map(el => this.findName(el.timestamp, 'time')),
        },
        yaxis: {
          labels: {
            minWidth: 40,
            style: {
              fontSize: '0.857rem',
            },
            formatter: val => this.formatBytes(Number(val), 2),
          },
          min: 0,
          max: this.maxVal,
          tickAmount: 5,
        },
        tooltip: {
          followCursor: false,
        },
        noData: {
          text: 'No data available',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: '14px',
          },
        },
      }
    },
    timeLensAnalytics() {
      return this.$store.state.storageLensV2.timeLens
    },
    gettingTimeLens() {
      return this.$store.state.storageLensV2.gettingTimeLens
    },
    maxVal() {
      const element = this.timeLensAnalytics.length > 0
        ? this.timeLensAnalytics.reduce((el, ele) => (el.datapoint > ele.datapoint ? el : ele))
        : 0
      return Math.floor(element.datapoint * (1 + 20 / 100))
    },
  },
  watch: {
    selectedUsageType() {
      this.getTimeLens()
    },
    bucket() {
      this.getTimeLens()
    },
    interval() {
      this.getTimeLens()
    },
    updateIndex() {
      this.getTimeLens()
    },
  },
  created() {
    this.getTimeLens()
  },
  methods: {
    getTimeLens() {
      this.$store
        .dispatch('storageLensV2/getTimeLens', {
          period: this.interval,
          usage: this.selectedUsageType,
          bucket: this.bucket?.value,
        })
        .catch(error => {
          this.errorToast(
            error.response?.data?.errors[0]
              || 'Something went wrong while fetching time lens data.',
          )
        })
        .finally(() => {
          this.counter++
        })
    },
    findName(name) {
      const d = new Date(name)
      if (this.interval === 1) {
        return `${d.getHours()}:00`
      }
      const month = d.getMonth() + 1
      const days = d.getDate()
      return `${month < 10 ? `0${month}` : month}/${
        days < 10 ? `0${days}` : days
      }`
    },
  },
}
</script>
<style lang="scss" scoped>
.analytics-loading {
  min-height: 355px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
